import React from 'react';
import { HeartCrackIcon, DollarSignIcon, HelpCircleIcon, AlertCircle, Quote } from 'lucide-react';
export function ProblemSection() {
  const stats = [{
    icon: HeartCrackIcon,
    stat: '1 de cada 31',
    title: 'niños diagnosticados',
    description: 'con autismo hoy en Estados Unidos, según datos actuales del CDC'
  }, {
    icon: DollarSignIcon,
    stat: '$20,000',
    title: 'al mes',
    description: 'puede costar un programa intensivo y coordinado para un niño neurodiverso'
  }, {
    icon: HelpCircleIcon,
    stat: '85-95%',
    title: 'de las familias',
    description: 'no puede costear directamente un programa completo de atención'
  }];
  return <section id="nosotros" className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-208" data-mp="3eew46qk1mpwg">
      <div className="max-w-6xl mx-auto" data-id="element-209" data-mp="1p2kknxir12q9">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16" data-id="element-210" data-mp="1k2xzn1woii6w">
          <div data-id="element-211" data-mp="1k52bc60tklhq">
            <div className="mp-problem-label" style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            background: '#fff3f3',
            border: '1px solid #ffcccc',
            borderRadius: '20px',
            padding: '6px 14px',
            marginBottom: '20px'
          }} data-id="element-212" data-mp="jd3n6mw0u9qw">
              <AlertCircle size={14} color="#CC0000" className="shrink-0" data-id="element-213" data-mp="123v181qyeobm" />
              <span style={{
              fontSize: '12px',
              fontWeight: 600,
              color: '#CC0000',
              letterSpacing: '0.5px'
            }} data-id="element-214" data-mp="125z3ygd49hab">
                Una realidad que no puede esperar
              </span>
            </div>
            <h2 className="mp-problem-title" style={{
            fontSize: '34px',
            fontWeight: 700,
            color: '#1a1a1a',
            lineHeight: 1.25,
            letterSpacing: '-0.3px',
            marginBottom: '20px'
          }} data-id="element-215" data-mp="3dtfbsdhrfrud">
              Cada semana, una familia no puede costear lo que su hijo necesita
              para desarrollarse
            </h2>
            <div className="mp-problem-quote" style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '12px',
            background: '#f0fae8',
            borderLeft: '3px solid #7DC920',
            borderRadius: '0 10px 10px 0',
            padding: '14px 18px',
            marginBottom: '24px'
          }} data-id="element-216" data-mp="y29w6iajfkdk">
              <Quote size={20} color="#7DC920" className="shrink-0" style={{
              marginTop: '2px'
            }} data-id="element-217" data-mp="1cpuyi9zl9fkf" />
              <p style={{
              fontSize: '15px',
              fontWeight: 600,
              color: '#2d5a1b',
              lineHeight: 1.5,
              fontStyle: 'normal'
            }} data-id="element-218" data-mp="1lqt61298k57r">
                El costo no debería determinar el futuro de un niño.
              </p>
            </div>
          </div>
          <div data-id="element-219" data-mp="1wdzgpx8jpn61">
            <img src="https://cdn.magicpatterns.com/uploads/eBEDv17LBRGEQhmeBueWEQ/heylloyd-image-1782595943394.png" alt="Madre preocupada con su hijo" className="w-full h-80 object-cover rounded-2xl shadow-lg" data-id="element-220" data-mp="20cyixa2w75ts" />
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-221" data-mp="1cnno098845nk">
          {stats.map((stat, index) => <div key={index} className="mp-problem-card bg-gray-50 rounded-2xl p-8 text-center shadow-md hover:shadow-xl hover:scale-[1.03] transition-all duration-300" data-id="element-222" data-mp="1hmqmtbxm1fn3" data-mpi={index}>
              <div className="mp-problem-icon inline-flex items-center justify-center w-16 h-16 bg-accent/10 rounded-full mb-6" data-id="element-223" data-mp="18lsqzgxbsefl">
                <stat.icon className="mp-problem-icon-svg w-8 h-8 text-accent" data-id="element-224" data-mp="10kbf47mj68yp" />
              </div>
              <p className="mp-problem-stat" style={{
            fontSize: '36px',
            fontWeight: 800,
            color: '#2d5a1b',
            lineHeight: 1.1,
            marginBottom: '4px'
          }} data-id="element-225" data-mp="vnb91wpol67l">
                {stat.stat}
              </p>
              <h3 className="mp-problem-card-title text-xl font-bold text-dark mb-3" data-id="element-226" data-mp="hsilqc3julqg">
                {stat.title}
              </h3>
              <p className="mp-problem-card-desc text-gray-600" data-id="element-227" data-mp="7vxdzj05awix">
                {stat.description}
              </p>
            </div>)}
        </div>
        <p style={{
        fontSize: '12px',
        color: '#999',
        textAlign: 'center',
        marginTop: '16px',
        fontStyle: 'italic'
      }} data-id="element-228" data-mp="3xgi5vm6d8gt">
          Estimación basada en datos del CDC (prevalencia) y reportes de costos
          de programas intensivos coordinados en EE.UU.
        </p>
      </div>
    </section>;
}